import { Component } from "@angular/core";

@Component({
  selector: "oms-empty",
  templateUrl: "empty.component.html"
})
export class EmptyComponent {
}
